//import { Utils } from '../../Common/vueutils'; //from '../../../Scripts/Views/vueutils';

//var utils = new Utils();

export class Repository {
  constructor() {
  }





}




// WEBPACK FOOTER //
// ./VueSrc/Common/Store/Security/PassChange_Repository.js